var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 406,
    viewBox: "0 0 406 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3399 202.652C21.3399 102.516 102.516 21.3399 202.652 21.3399C302.788 21.3399 383.964 102.516 383.964 202.652C383.964 302.788 302.788 383.964 202.652 383.964C102.516 383.964 21.3399 302.788 21.3399 202.652ZM202.652 0C90.7304 0 0 90.7304 0 202.652C0 314.574 90.7304 405.304 202.652 405.304C314.574 405.304 405.304 314.574 405.304 202.652C405.304 90.7304 314.574 0 202.652 0ZM237.928 202.313L179.926 168.733L179.587 235.893C183.657 235.554 235.893 205.366 237.928 202.313ZM131.761 279.988C93.4325 275.917 91.7366 263.367 89.7014 225.378C84.8011 124.757 95.6332 124.51 170.08 122.81C172.929 122.745 175.871 122.678 178.909 122.603C210.114 121.925 242.677 122.264 273.543 124.977C311.193 128.708 313.567 142.954 315.603 179.926C316.62 201.634 317.977 250.139 307.123 266.081C297.037 281.802 262.567 282.218 236.834 282.529C233.142 282.574 229.63 282.616 226.395 282.701C194.851 283.379 162.627 283.04 131.761 279.988Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1795d53cdd4cb5194a3b4b30138a53a6.svg";
export { ForwardRef as ReactComponent };